import { Injectable, Injector } from '@angular/core';
import { User } from './user';
import { Observable } from 'rxjs';
import { HttpService } from '../../core/data/http.service';
import { TimeSheetsStore } from 'projects/desktop/src/app/modules/timesheets/data/time-sheets.store';
import { cacheResult } from '../../core/public-api';
import { environment } from 'projects/desktop/src/environments/environment';
import { Memoize } from '../../core/utils/decorators/memoize-decorator';
import { SearchBody } from 'projects/app-misc/src/app/modules/search/data/searchBody';

// TODO DELETE THIS
export class Avatar {
    shortCode: string;
    bgColor: string;
}

@Injectable({
    providedIn: 'root'
})
export class UserService extends HttpService {
    constructor(
        protected injector: Injector,
        protected timeSheetsStore: TimeSheetsStore
    ) {
        super(injector);
    }

    saveUser(data: any): Observable<User> {
        return this.putData('/user/update', data, User)
    }

    @Memoize()
    getAllUsers(): Observable<User[]> {
        return this
            .getData(`/user/list`, User)
            .pipe(
                cacheResult(environment.dataDefaultCacheTime)
            );
    }

    getActiveUsers(): Observable<User[]> {
        return this
            .getData(`/user/list/enabled`, User)
            .pipe(
                cacheResult(environment.dataDefaultCacheTime)
            );
    }

    getTrackUsers(): Observable<User[]> {
        return this
            .getData(`/user/list/enabled-time-tracking`, User)
    }

    getUsersForKiosk(): Observable<User[]> {
        return this
            .getData(`/user/list/for-shop-kiosk`, User)
    }

    searchUsers(reqString: string): Observable<User[]> {
        return this.postData(`/user/list/search`, {
            query: reqString
        } as SearchBody, User);
    }

    getProjectManagers(): Observable<User[]> {
        return this
            .getData(`/user/list/managers`, User)
            .pipe(
                cacheResult(environment.dataDefaultCacheTime)
            );
    }

    // loadCardsForAllUsers(dateFrom: string, dateTo: string): Observable<TimeCard[]> {
    // 	return this.doHttpGet<TimeCard[]>(`/time_card/list/${dateFrom}:${dateTo}`)
    // 		.pipe(
    // 			tap(timeCards => {
    // 				this.timeSheetsStore.set(timeCards)
    // 			}),
    // 			autoSubscribe()
    // 		)

    // }


}
